import React from 'react';
import { FileIcon, XIcon, FileTextIcon, ImageIcon, TableIcon } from 'lucide-react';
interface Document {
  id: string;
  name: string;
  type: string;
  uploadedAt: string;
  uploadedBy: string;
  size: string;
}
interface DocumentViewerProps {
  isOpen: boolean;
  onClose: () => void;
}
const DocumentViewer: React.FC<DocumentViewerProps> = ({
  isOpen,
  onClose
}) => {
  if (!isOpen) return null;
  // Mock document data
  const documents: Document[] = [{
    id: '1',
    name: 'Bill_of_Lading.pdf',
    type: 'PDF',
    uploadedAt: '2024-01-15 09:30 AM',
    uploadedBy: 'John Smith',
    size: '156 KB'
  }, {
    id: '2',
    name: 'Delivery_Receipt.pdf',
    type: 'PDF',
    uploadedAt: '2024-01-15 10:15 AM',
    uploadedBy: 'Jane Doe',
    size: '89 KB'
  }, {
    id: '3',
    name: 'Load_Details.xlsx',
    type: 'Excel',
    uploadedAt: '2024-01-15 11:00 AM',
    uploadedBy: 'Mike Johnson',
    size: '245 KB'
  }, {
    id: '4',
    name: 'Proof_of_Delivery.jpg',
    type: 'Image',
    uploadedAt: '2024-01-17 02:30 PM',
    uploadedBy: 'Sarah Wilson',
    size: '1.2 MB'
  }];
  const getFileIcon = (type: string) => {
    switch (type) {
      case 'PDF':
        return <FileTextIcon size={20} className="text-red-500" data-id="element-279" />;
      case 'Excel':
        return <TableIcon size={20} className="text-green-500" data-id="element-280" />;
      case 'Image':
        return <ImageIcon size={20} className="text-blue-500" data-id="element-281" />;
      default:
        return <FileIcon size={20} className="text-gray-500" data-id="element-282" />;
    }
  };
  return <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50" data-id="element-283">
      <div className="relative top-5 mx-auto p-5 border w-full max-w-4xl shadow-lg rounded-lg bg-white" data-id="element-284">
        <div className="flex items-center justify-between mb-4" data-id="element-285">
          <h2 className="text-xl font-semibold text-gray-800" data-id="element-286">
            Shipment Documents
          </h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-100 transition-colors" data-id="element-287">
            <XIcon size={20} className="text-gray-500" data-id="element-288" />
          </button>
        </div>
        <div className="overflow-x-auto" data-id="element-289">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-290">
            <thead className="bg-gray-50" data-id="element-291">
              <tr data-id="element-292">
                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-293">
                  File Name
                </th>
                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-294">
                  Type
                </th>
                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-295">
                  Uploaded At
                </th>
                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-296">
                  Uploaded By
                </th>
                <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-297">
                  Size
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-298">
              {documents.map(doc => <tr key={doc.id} className="hover:bg-gray-50" data-id="element-299">
                  <td className="px-4 py-3 text-sm text-primary-700 font-medium" data-id="element-300">
                    <div className="flex items-center" data-id="element-301">
                      {getFileIcon(doc.type)}
                      <span className="ml-2" data-id="element-302">{doc.name}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500" data-id="element-303">
                    {doc.type}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500" data-id="element-304">
                    {doc.uploadedAt}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500" data-id="element-305">
                    {doc.uploadedBy}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500" data-id="element-306">
                    {doc.size}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};
export default DocumentViewer;